module.exports = __webpack_public_path__ + "img/plus-new.937d3d2f.svg";